<template>
    <div style="height:1551px ;  position: relative;">
        <TitleView :titleData="resultData" />
        <!-- 内容部 -->
        <div class="centent-box">
            <!-- 左 -->
            <div class="centent-left-box">
                <!-- 人体成分概念 -->
                <div class="content-comment-bg">
                    <BodyComponentTable :bodyData="parseBodyData" />
                </div>

                <!-- 脂肪肌肉评估 -->
                <div class="content-comment-bg">
                    <EvaluateView :bodyData="parseBodyData" :lstBody="resultData.lstBodyLast" v-if="hashLastBody" />
                    <EvaluateView :bodyData="parseBodyData" :lstBody="resultData.lstBody" v-else />
                </div>
                <!-- 肥胖分享 -->
                <div class="content-comment-bg">
                    <FatView :bodyData="parseBodyData" :lstBody="resultData.lstBodyLast" v-if="hashLastBody" />
                    <FatView :bodyData="parseBodyData" :lstBody="resultData.lstBody" v-else />
                </div>
                <!-- 基础代谢 -->
                <div class="content-comment-bg">
                    <EvaluateNoTitleView :bodyData="parseBodyData" :lstBody="resultData.lstBodyLast"
                        v-if="hashLastBody" />
                    <EvaluateNoTitleView :bodyData="parseBodyData" :lstBody="resultData.lstBody" v-else />
                </div>
                <!-- 内脏脂肪等级 -->
                <div class="content-comment-bg">
                    <FatGradeNoTitleView :bodyData="parseBodyData" :lstBody="resultData.lstBodyLast"
                        v-if="hashLastBody" />
                    <FatGradeNoTitleView :bodyData="parseBodyData" :lstBody="resultData.lstBody" v-else />
                </div>

                <!-- 体重 肌肉量标准 -->
                <div class="content-comment-bg">
                    <BodyComponentNoTitleTable :bodyData="parseBodyData" />
                </div>

            </div>
            <!-- 右 -->
            <div class="centent-right-box">
                <div class="content-comment-bg body-model">
                    <div class="coment-title">身体模型</div>
                    <img class="body-model-img" src="../assets/report-3d-preview.png" />
                </div>
                <!-- 体围测量 -->
                <div class="content-comment-bg" v-if="resultData.authorizationCode != 420276
            && resultData.authorizationCode != 980989
            && resultData.authorizationCode != 980990
            && resultData.authorizationCode != 420277">
                    <BodyGirthView :reportResult="resultData" />
                </div>
                <!-- 节段 -->
                <div>
                    <!-- <BodySegmentsView></BodySegmentsView> -->
                </div>

            </div>

        </div>
        <!-- 历史 -->

        <div class="history-content content-comment-bg">
            <HistoryView :historyData="historyData" />
        </div>
        <div style="display: flex; position: absolute;bottom: 0; ">
            <img style=" width: 1100px; height: 18px; " src="../assets/ic-bottom-img.png" />
        </div>
    </div>
</template>
<script>

import TitleView from "@/views/TitleView.vue";
import BodyComponentTable from '@/components/BodyComponentTable.vue';
import EvaluateView from '@/components/EvaluateView.vue';
import EvaluateNoTitleView from '@/components/EvaluateNoTitleView.vue';
import BodyComponentNoTitleTable from '@/components/BodyComponentNoTitleTable.vue';
import HistoryView from '@/components/HistoryView.vue';
import BodyGirthView from "@/components/BodyGirthView.vue";
import BodySegmentsView from '@/components/BodySegmentsView.vue';
import FatView from '@/components/FatView.vue';
import FatGradeNoTitleView from "@/components/FatGradeNoTitleView.vue";


export default {
    data() {
        return {

        }
    },
    props: {
        resultData: {
            type: Object,
            required: true
        },
        historyData: {
            type: Object,
            required: true
        }
    },
    components: {
        TitleView,
        BodyComponentTable,
        EvaluateView,
        EvaluateNoTitleView,
        BodyComponentNoTitleTable,
        HistoryView,
        BodyGirthView,
        BodySegmentsView,
        FatView,
        FatGradeNoTitleView
    },
    mounted() {
    },
    computed: {
        hashLastBody() {
            return this.resultData.lstBodyLast && Object.keys(this.resultData.lstBodyLast).length > 0
        },
        // 计算属性，用于转换 rawData 为 JSON  
        parseBodyData() {
            if (this.resultData.bodyResult != "") {
                try {
                    // 尝试将 rawData 转换为 JSON 对象  
                    return JSON.parse(this.resultData.bodyResult);

                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    // 可以返回一个空对象或其他默认值  
                    return null;
                }
            }
            return null

        },




    }
}
</script>


<style scoped>
/* 内容局域 */
.centent-box {
    background: #FFF;
    display: flex;
    padding: 0px 35px 0px 35px;
}

/* 内容局域  头部文字的公共样式*/
.centent-comment-title {
    font-size: 19px;
    color: #333333;
    font-weight: bold;
    text-align: left;
}

.content-comment-bg {
    background: #FFFFFF;
    margin-top: 20px;
}

/* 右边 */
.centent-right-box {
    display: flex;
    flex-direction: column;
    width: 383px;
    margin-left: 35px;

}

.body-model {
    height: 478px;
}

.body-model-img {
    width: 173px;
    height: 340px;
    margin-top: 32px;
}

.coment-title {
    font-weight: 500;
    font-size: 19px;
    color: #333333;
    text-align: left;
}

.history-content {
    margin-left: 35px;
    margin-right: 35px;
}
</style>